import { useQuery } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth.ts';
import { apiFetch } from 'utils/apiUtils.ts';
import { OperatorMetadata } from 'schemas/metadata/operators.ts';

export interface OperatorMetadataResponse {
  META: {
    Timestamp: string;
  };
  OperatorRefData: OperatorMetadata[];
}

export default function useFetchOperatorMetadata() {
  const { tokens } = useAuth();
  return useQuery({
    queryKey: ['metadata-operators'],
    queryFn: () => apiFetch<OperatorMetadataResponse>({
      path: 'metadata/operators',
      method: 'GET',
      accessToken: String(tokens.accessToken),
    }),
  });
}
